import api from './api';
import { sendHttpRequest } from 'actions/actionCreators/httpActions';
import * as actionTypes from './actionTypes';

export function loadApplicationTheme() {
  return async dispatch => {
    try {
      const theme = await dispatch(sendHttpRequest(api.loadApplicationTheme()));
      dispatch({ type: actionTypes.APPLICATION_THEME_LOAD_SUCCEEDED });
      return theme;
    } catch (error) {
      dispatch({ type: actionTypes.APPLICATION_THEME_LOAD_FAILED });
      return null;
    }
  };
}
